import { getLocale } from "../runtime";

const sv_instock = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `I lager`
};

const instock = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_instock(inputs)
	return "inStock";
};

export { instock as "inStock" };